module.exports = __webpack_public_path__ + "static/media/scan_wristband.cb92cb07.svg";